var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6243 7.49935C10.6243 7.15417 10.3445 6.87435 9.99935 6.87435C9.65417 6.87435 9.37435 7.15417 9.37435 7.49935L9.37435 9.37437H7.49935C7.15417 9.37437 6.87435 9.65419 6.87435 9.99937C6.87435 10.3445 7.15417 10.6244 7.49935 10.6244H9.37435V12.4993C9.37435 12.8445 9.65417 13.1243 9.99935 13.1243C10.3445 13.1243 10.6243 12.8445 10.6243 12.4993L10.6243 10.6244H12.4993C12.8445 10.6244 13.1243 10.3445 13.1243 9.99937C13.1243 9.65419 12.8445 9.37437 12.4993 9.37437H10.6243V7.49935Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 1.04102C5.0518 1.04102 1.04102 5.0518 1.04102 9.99935C1.04102 14.9469 5.0518 18.9577 9.99935 18.9577C14.9469 18.9577 18.9577 14.9469 18.9577 9.99935C18.9577 5.0518 14.9469 1.04102 9.99935 1.04102ZM2.29102 9.99935C2.29102 5.74215 5.74215 2.29102 9.99935 2.29102C14.2565 2.29102 17.7077 5.74215 17.7077 9.99935C17.7077 14.2565 14.2565 17.7077 9.99935 17.7077C5.74215 17.7077 2.29102 14.2565 2.29102 9.99935Z",
    fill: "#3B82F6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddOutlined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_outlined.6b49b1e99cd59058bbf1441bd98b1117.svg";